import { Drawer } from 'antd';
import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import Footers from '../components/common/Footers';
import Menu from '../components/common/Menu';
import ResponsiveUserSidebar from '../components/common/ResponsiveUserSidebar';
import Submenu from '../components/common/Submenu';
import UserPanelMenu from '../components/common/UserPanelMenu';
import UserPanelSidebar from '../components/common/UserPanelSidebar';
import { useUserInfo } from '../context/UserContext';


const UserPanelLayout = ({ children,setregister }) => {
  const {getUser} = useUserInfo();
  useEffect(() => {
    getUser.reFetch()

  }, [])
  
  const [showMenu, setshowMenu] = useState(false);
  const closeMenu = () => {
    setshowMenu(false);
  };
  const drawerStyles = {
 
    header: {
     display:"none"
    },
 
  };
  return (
    <div className='UserPanelLayout'>
      
      <UserPanelSidebar />
      <div/>
      <Drawer
      width={400}
      placement="right"
      onClose={closeMenu}
      open={showMenu}
      styles={drawerStyles}
      
    >
      <ResponsiveUserSidebar  setShow={setshowMenu}/>
    </Drawer>
      <div className=''>
      <UserPanelMenu showMenu={setshowMenu}/>
      <main className='UserPanelLayout--main'>
        <div className='user-container'>
        <Outlet />
        </div>
    
      </main>
      
       
      </div>

 
    </div>
  )
}

export default UserPanelLayout